import { OrgOverviewStatistic } from './../types';
import android from './orgOverviewStatsAndroid.json';
import ios from './orgOverviewStatsiOS.json';
import allApps from './orgOverviewStatsAllApps.json';

export const generateOrgOverviewStats = (): Record<string, OrgOverviewStatistic[]> => {
    const stats: Record<string, OrgOverviewStatistic[]> = {
        'org-demo': allApps as OrgOverviewStatistic[],
        'app-apollo-ios': ios as OrgOverviewStatistic[],
        'app-apollo-android': android as OrgOverviewStatistic[],
    };
    return stats;
};
